module.exports = __webpack_public_path__ + "media/1-7.a7b4014f.mp4";